import { GETNET_API_URL } from "../../utils/contextHelpers";
import { request, buildQuery, deduplicate } from "./core";

const GETNET_AUTH = "Basic " + btoa("admin:kesp");

export const getnetLogin = () => {
  const key = "getnet-login-admin";
  return deduplicate(key, () =>
    request(
      `${GETNET_API_URL}login?${buildQuery({
        password: "kesp",
        username: "admin",
      })}`,
      {
        method: "POST",
        headers: new Headers({ Authorization: GETNET_AUTH }),
      }
    )
  );
};

export const getnetPagar = (pago) => {
  const headers = new Headers({ "Content-Type": "application/json;charset=UTF-8" });
  headers.append("Authorization", GETNET_AUTH);
  return request(`${GETNET_API_URL}getnet/pagar`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      cancelar: pago?.cancelar ?? "",
      monto: Number(pago?.monto) || 0,
      referencia: pago?.referencia ?? "",
      retorno: pago?.retorno ?? "",
    }),
  });
};
